export enum StatusEnum {
  INITIAL,
  PENDING,
  LOADED,
  ERROR,
}
